import { getParameterFromURL } from "./getParameterFromUrl";

export default function getCurrencySymbol(): string {
  const subscrUK = getParameterFromURL("subscrUK");
  const subscrEU = getParameterFromURL("subscrEU");

  if (subscrUK) {
    return "£";
  }

  if (subscrEU) {
    return "€";
  }

  return "$";
}
